import { render } from "./EssayHead.vue?vue&type=template&id=600541a3&scoped=true"
import script from "./EssayHead.vue?vue&type=script&lang=js"
export * from "./EssayHead.vue?vue&type=script&lang=js"

import "./EssayHead.vue?vue&type=style&index=0&id=600541a3&scoped=true&lang=css"
import "@/assets/css/essayWriting.sass?vue&type=style&index=1&id=600541a3&lang=sass&scoped=true"

import exportComponent from "/Users/priscillacancar/Documents/Coding/1) Engram-site/Engram/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-600541a3"]])

export default __exports__